import { Heading, Img } from "./..";
import React from "react";

export default function Header({ ...props }) {
  return (
    <header {...props} className={`${props.className} flex justify-center items-center py-5`}>
      <div className="container-xs flex items-center md:flex-col md:gap-5 md:px-5">
        <Img
          src="images/img_header_logo.png"
          alt="Headerlogo"
          className="h-16 w-16 mr-12"
        />
        <ul className="flex flex-wrap gap-12">
          <li>
            <a href="#home">
              <Heading size="headingmd" as="h1" className="text-4xl font-bold text-white">
                Home
              </Heading>
            </a>
          </li>
          <li>
            <a href="#aboutme">
              <Heading size="headingmd" as="h1" className="text-4xl font-bold text-white">
                About me
              </Heading>
            </a>
          </li>
          <li>
            <a href="#study">
              <Heading size="headingmd" as="h1" className="text-4xl font-bold text-white">
                Study
              </Heading>
            </a>
          </li>
          <li>
            <a href="#work">
              <Heading size="headingmd" as="h1" className="text-4xl font-bold text-white">
                Work
              </Heading>
            </a>
          </li>
          <li>
            <a href="#projects">
              <Heading size="headingmd" as="h1" className="text-4xl font-bold text-white">
                Projects
              </Heading>
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
}
